/**
 * Middleware to handle Riskified tracking script on route changes.
 *
 * This middleware triggers the Riskified tracking script (RISKX) when
 * the route changes, ensuring proper tracking of user navigation.
 *
 * @returns {void} Calls Riskified tracking method if conditions are met
 *
 * @example
 * // Automatically tracks page navigation using Riskified script
 * export default defineNuxtRouteMiddleware((to, from) => { ... })
 *
 * @note
 * - Only works on client-side
 * - Requires window.RISKX to be defined
 * - Only triggers when route path changes
 */
export default defineNuxtRouteMiddleware((to, from) => {
  if (
    to.path !== from.path &&
    typeof window !== 'undefined' &&
    typeof window.RISKX !== 'undefined' &&
    import.meta.client
  ) {
    window.RISKX.go(to.path)
  }
})
